import { pushToGTM, sendMixpanelTrackEvent } from "@lib/gtmUtility"
import { GA_EVENT_COMMON } from "@constants"

const eventObjBase = {
    category: "Cart",
    action: "",
    label: "",
    eventName: "newGAEvent",
}

const addEvent = ({ label, action, eventName, category }, eventData = {}) => {
    const eventObj = Object.assign({}, eventObjBase)
    if (!category) {
        eventObj.category = "Cart"
    }
    eventObj.action = action
    eventObj.label = label
    if (category) eventObj.category = category
    if (eventName) eventObj.eventName = eventName
    else eventObj.eventName = "newGAEvent"
    pushToGTM(eventObj, eventData)
}

export default {
    onApplyCouponGA: (label, action, category) => {
        addEvent({
            label,
            action,
            category,
        })
    },
    onRemoveCouponGA: (label, action, category) => {
        addEvent({
            label,
            action,
            category,
        })
    },
    onRenewCarePlanGA: (label, action, category) => {
        addEvent({
            label,
            action,
            category,
        })
    },
    onRenewCarePlanVisibleGA: (label, action, category) => {
        addEvent({
            label,
            action,
            category,
        })
    },
    onDiscountBreakupGA: (label, action, category) => {
        addEvent({
            label,
            action,
            category,
        })
    },
    onScrollBillSummaryGA: (label, action, category) => {
        addEvent({
            label,
            action,
            category,
        })
    },
    onPageViewEvent: (label, category) => {
        addEvent({
            label,
            action: "Page View Action",
            eventName: GA_EVENT_COMMON.pageViewEventName,
            category,
        })
    },
    onAddressSelectionGA: (label, action, category) => {
        addEvent({
            label,
            action,
            category,
        })
    },
    onWantFreeShippingGA: (label, action, category) => {
        addEvent({
            label,
            action,
            category,
        })
    },
    onViewCouponDetailsGA: (label, action, category) => {
        addEvent({
            label,
            action,
            category,
        })
    },
    onCarePlanWillRemoveGA: (label, action, category) => {
        addEvent({
            label,
            action,
            category,
        })
    },
    onCheckoutGA: (label, action, category, eventData = {}) => {
        addEvent(
            {
                label,
                action,
                category,
            },
            eventData
        )
    },
    onCarePlanUpsellGA: (label, action, category) => {
        addEvent({
            label,
            action,
            category,
        })
    },
    onCarePlanUpsellBottomSheetGA: (label, action, category) => {
        addEvent({
            label,
            action,
            category,
        })
    },
    onEmptyCartGA: (label, action, category) => {
        addEvent({
            label,
            action,
            category,
        })
    },
    onRemoveCarePlanGA: (label, action, category) => {
        addEvent({
            label,
            action,
            category,
        })
    },
    onAddDoneInOneItemIntoCartGA: (label, action, category) => {
        addEvent({
            label,
            action,
            category,
        })
    },
    onCpUpdateInfoClick: (label, action, category) => {
        addEvent({
            label,
            action,
            category,
        })
    },
    whyPrescriptionNeededInfoIconClickGA: (label, action, category) => {
        addEvent({
            label,
            action,
            category,
        })
    },
    onTataPointsWidgetHelpIconGA: (label, action, category) => {
        addEvent({
            label,
            action,
            category,
        })
    },
    dioCartTypeGA: (label, action, category) => {
        addEvent({
            label,
            action,
            category,
        })
    },
    dioAddToCartGA: (label, action, category) => {
        addEvent({
            label,
            action,
            category,
        })
    },
    dioSeeAllGA: (label, action, category) => {
        addEvent({
            label,
            action,
            category,
        })
    },
    dioAddMedicineToCartGA: (label, action, category) => {
        addEvent({
            label,
            action,
            category,
        })
    },
    dioSkipMedGA: (label, action, category) => {
        addEvent({
            label,
            action,
            category,
        })
    },
    autoAttachDialogShownGA: (label, action, category) => {
        addEvent({
            label,
            action,
            category,
        })
    },
    autoAttachDialogContinueGA: (label, action, category) => {
        addEvent({
            label,
            action,
            category,
        })
    },
    onUpsellProductClickGA: (label, category, uclid) => {
        addEvent(
            {
                label,
                action: "Click on widget",
                category,
            },
            {
                uclid: uclid,
                onlineSalesEvent: uclid ? "funnel_click" : "",
            }
        )
    },
    onUpsellProductAddToCartGA: (label, category, uclid) => {
        let price = label?.entity_price.replace?.("₹", "")
        addEvent(
            {
                label,
                action: "Add to Cart-Widget",
                category,
            },
            {
                id: label?.entity_id,
                mrp: price,
                uclid: uclid,
                quantity: label?.quantity,
                mfId: label?.manufacturerId,
                onlineSalesEvent: price > 0 ? "funnel_add2cart" : "",
            }
        )
    },
    onPLAAddToCartClick: (label, uclid) => {
        addEvent(
            {
                label,
                action: "Cart",
                category: "PLA Add To Cart Click",
            },
            {
                uclid: uclid,
                skipGATracking: true,
                onlineSalesEvent: uclid ? "funnel_click" : "",
            }
        )
    },
    onWidgetPLAImpression: (label, category, uclid) => {
        addEvent(
            {
                label: label,
                action: "PLA Impressions",
                category,
            },
            {
                uclid: uclid,
                skipGATracking: true,
                onlineSalesEvent: uclid ? "funnel_impression" : "",
            }
        )
    },

    onWidgetClickGA: (label, action, category) => {
        addEvent({ label, action, category })
    },
    onChangeLabGA: (label, action, category) => {
        addEvent({
            label,
            action,
            category,
        })
    },
    onRemoveTestGA: (label, action, category) => {
        addEvent({
            label,
            action,
            category,
        })
    },
    onCarePlanCODBenefit: (label) => {
        addEvent({
            label,
            action: "Care Plan Locked Benefit Info",
        })
    },
    onTogglingVasCheckboxGA: (label, action, category) => {
        addEvent({
            label,
            action,
            category,
        })
    },
    onClickingKnowMoreGA: (label, action, category) => {
        addEvent({
            label,
            action,
            category,
        })
    },
    onNeucoinEditApplyGA: (value) =>
        addEvent({
            category: "Edit Neucoins - Cart",
            action: "Apply",
            label: value,
        }),

    onNeucoinEditClickGA: () =>
        addEvent({
            category: "Cart",
            action: "Edit Neucoins",
            label: "Click",
        }),
    onNeucoinEditViewGA: () =>
        addEvent({
            category: "Cart",
            action: "Edit Neucoins Popup",
            label: "Shown",
        }),
    onNeucoinEditApplyErrorGA: (value) =>
        addEvent({
            category: "Edit Neucoins - Cart",
            action: "Apply",
            label: value,
        }),
    onNeucoinEditCloseGA: () =>
        addEvent({
            category: "Cart",
            action: "Close Edit Neucoins",
            label: "Click",
        }),
}

export const mixPanelEvents = {
    onSkuCardClick: (mixPanelData = {}) => {
        sendMixpanelTrackEvent("sku_card_clicked", mixPanelData)
    },
    onSkuAddedToCart: (mixPanelData = {}) => {
        sendMixpanelTrackEvent("sku_added_to_cart", mixPanelData)
    },
    onApplyCoupon: (mixPanelData = {}) => {
        sendMixpanelTrackEvent("apply_coupon", mixPanelData)
    },
    onViewAllCoupons: (mixPanelData = {}) => {
        sendMixpanelTrackEvent("view_all_coupons", mixPanelData)
    },
    onRemoveCoupon: (mixPanelData = {}) => {
        sendMixpanelTrackEvent("remove_coupon", mixPanelData)
    },
    onCouponApplied: (mixPanelData = {}) => {
        sendMixpanelTrackEvent("coupon_applied", mixPanelData)
    },
    onCouponError: (mixPanelData = {}) => {
        sendMixpanelTrackEvent("coupon_error", mixPanelData)
    },
    onChangeAddress: (mixPanelData = {}) => {
        sendMixpanelTrackEvent("change_address", mixPanelData)
    },
    onCheckout: (mixPanelData = {}) => {
        sendMixpanelTrackEvent("cart_checkout", mixPanelData)
    },
    onChangeLab: (mixPanelData = {}) => {
        sendMixpanelTrackEvent("change_lab", mixPanelData)
    },
    onInsuranceBottomsheetShown: (mixPanelData = {}) => {
        sendMixpanelTrackEvent("insurance_upsell_bottomsheet_shown", mixPanelData)
    },
    onInsuranceBottomsheetClicked: (mixPanelData = {}) => {
        sendMixpanelTrackEvent("insurance_upsell_bottomsheet_clicked", mixPanelData)
    },
    onCartInsuranceWidgetClicked: (mixPanelData = {}) => {
        sendMixpanelTrackEvent("cart_insurance_widget_clicked", mixPanelData)
    },
}
